'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AGENT = exports.AGENT = 'AGENT';
var VISITOR = exports.VISITOR = 'VISITOR';
var BOT = exports.BOT = 'BOT';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/constants/SenderTypes.js
// module id = 98
// module chunks = 0 1